export default __webpack_public_path__ + "static/media/rhoUsdt_logo.d43a6782.png";